import { ThemeColors } from '../../../'

export interface NewFaxLoadingViewColors {
  Background: ThemeColors
  CircularProgress: {
    TrackColor: ThemeColors
    ProgressColor: ThemeColors
  }
}

export const newFaxLoadingViewColors: NewFaxLoadingViewColors = {
  Background: {
    default: 'transparent',
  },
  CircularProgress: {
    TrackColor: {
      default: 'bg.muted',
    },
    ProgressColor: {
      default: 'brand.solid',
    },
  },
}
